import { fetchWithCache, getCachedData } from "../services/apiService";

export const userPending = async ({ setPending }) => {
  // Show cached data immediately if available
  const cached = getCachedData("/api/user/userPending", {});
  if (cached) {
    setPending(cached);
  }

  try {
    const data = await fetchWithCache(
      "/api/user/userPending",
      {
        method: "GET",
        retries: 2,
        timeout: 10000,
      },
      true,
    );

    if (Array.isArray(data)) {
      setPending(data);
    } else if (!cached) {
      setPending([]);
    }
  } catch (error) {
    if (!cached) {
      setPending([]);
    }
  }
};
